import { useContext, useState, useEffect } from "react";
import { UserDataContext } from "../components/UserDataContext";
import VN from "../components/VN";
import { useNavigate } from "react-router-dom";
import ListNurseUnverified from "./ListNurseUnverified";
import QueryNurseUnverified from "./QueryNurseUnverified";
import {
  Button,
  Typography,
  Container,
  Box,
  Paper,
  Divider,
  Collapse,
} from "@mui/material";

import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";

import NurseAdd from "./NurseAdd";

export default function Menu() {
  const { userData } = useContext(UserDataContext);
  const navigate = useNavigate();
  const [activeForm, setActiveForm] = useState(null);

  useEffect(() => {
    console.log("USER DATA:", userData);

    if (userData?.group === undefined) {
      return;
    }

    console.log("group: ", userData.group);

    if (Number(userData.group) !== 2) {
      navigate("/nopermission", { replace: true });
    }
  }, [userData, navigate]);
  const handleToggleForm = (formName) => {
    console.log("Toggling form:", formName);
    setActiveForm((prev) => (prev === formName ? null : formName));
  };

  return (
    <Box
      sx={{
        backgroundColor: "#f8fafc",
        minHeight: "100vh",
        pb: 6,
      }}
    >
      <VN userData={userData} />

      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: "16px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.04)",
            backgroundColor: "#ffffff",
          }}
        >
          {/* NAGŁÓWEK PANELU */}
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontWeight: 700,
                color: "#1e293b",
                letterSpacing: "-0.5px",
                mb: 1,
              }}
            >
              Panel Osoby Weryfikującej
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "#64748b",
              }}
            >
              Zarządzaj strukturą opiekunek, pielęgniarek i fizjoterapeutów w
              serwisie.
            </Typography>
          </Box>

          <Divider sx={{ mb: 4 }} />

          {/* PASEK PRZYCISKÓW */}
          <Box
            sx={{
              display: "flex",
              flexDirection: {
                xs: "column",
                md: "row",
              },
              gap: 2,
              justifyContent: "flex-start",
              alignItems: "stretch",
            }}
          >
            {/* NIEZWERYFIKOWANE OPIEKUNKI */}
            <Button
              variant="contained"
              startIcon={<AssignmentIndIcon />}
              onClick={() => handleToggleForm("unverified-list")}
              sx={{
                flex: 1,
                py: 1.5,
                px: 3,
                fontWeight: 600,
                fontSize: "0.95rem",
                borderRadius: "10px",
                textTransform: "none",

                backgroundColor:
                  activeForm === "caregiver-add" ? "#8f1515" : "#b71c1c",

                boxShadow: "0 4px 12px rgba(183, 28, 28, 0.25)",

                "&:hover": {
                  backgroundColor: "#8f1515",
                  boxShadow: "0 6px 16px rgba(183, 28, 28, 0.35)",
                },
              }}
            >
              Lista niezweryfikowanych opiekunek
            </Button>
            {/* LISTA OPIEKUNEK ZWERYFIKOWANYCH */}
            <Button
              variant="contained"
              startIcon={<VolunteerActivismIcon />}
              onClick={() => handleToggleForm("caregiver-add")}
              sx={{
                flex: 1,
                py: 1.5,
                px: 3,
                fontWeight: 600,
                fontSize: "0.95rem",
                borderRadius: "10px",
                textTransform: "none",

                backgroundColor:
                  activeForm === "caregiver-add" ? "#1b5e20" : "#2e7d32",

                boxShadow: "0 4px 12px rgba(46, 125, 50, 0.25)",

                "&:hover": {
                  backgroundColor: "#1b5e20",
                  boxShadow: "0 6px 16px rgba(46, 125, 50, 0.35)",
                },
              }}
            >
              Lista zweryfikowanych opiekunek
            </Button>
            {/* DODANIE PYTAŃ W KWESTIONARIUSZU */}
            <Button
              variant="contained"
              startIcon={<LocalHospitalIcon />}
              onClick={() => handleToggleForm("questionnaire")}
              sx={{
                flex: 1,
                py: 1.5,
                px: 3,
                fontWeight: 600,
                fontSize: "0.95rem",
                borderRadius: "10px",
                textTransform: "none",
                backgroundColor:
                  activeForm === "nurse-add" ? "#0d1b60" : "#1a237e",
                boxShadow: "0 4px 12px rgba(26, 35, 126, 0.2)",
                "&:hover": {
                  backgroundColor: "#0d1b60",
                  boxShadow: "0 6px 16px rgba(26, 35, 126, 0.3)",
                },
              }}
            >
              Kwestionariusz - pytania
            </Button>
          </Box>

          {/* SEKCJA ZAWARTOŚCI */}
          <Collapse in={Boolean(activeForm)} timeout="auto" unmountOnExit>
            <Box
              sx={{
                mt: 4,
                pt: 3,
                borderTop: "1px dashed #cbd5e1",
              }}
            >
              {/* DODANIE OSOBY WERYFIKUJĄCEJ */}
              {activeForm === "nurse-add" && (
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      mb: 2,
                      fontWeight: 600,
                    }}
                  >
                    Formularz dodawania osoby weryfikującej
                  </Typography>

                  <NurseAdd onSuccess={() => setActiveForm(null)} />
                </Box>
              )}

              {/* DODANIE OPIEKUNKI */}
              {activeForm === "caregiver-add" && (
                <Typography>
                  Formularz dopisania opiekunki (w trakcie wdrażania)
                </Typography>
              )}

              {/* PRZYPISANIE OPIEKUNKI */}
              {activeForm === "assign-caregiver" && (
                <Typography>
                  Formularz przypisania (w trakcie wdrażania)
                </Typography>
              )}

              {/* LISTA NIEZWERYFIKOWANYCH */}
              {activeForm === "unverified-list" && (
                <Box>
                  <Typography>
                    Lista niezweryfikowanych opiekunek (w trakcie wdrażania)
                  </Typography>
                  <ListNurseUnverified onSuccess={() => setActiveForm(null)} />
                </Box>
              )}
              {/* LISTA NIEZWERYFIKOWANYCH */}
              {activeForm === "questionnaire" && (
                <Box>
                  <Typography>Kwestionariusz</Typography>
                  <QueryNurseUnverified onSuccess={() => setActiveForm(null)} />
                </Box>
              )}
            </Box>
          </Collapse>
        </Paper>
      </Container>
    </Box>
  );
}
